import { Dispatch } from 'react-redux';

import { StoreState } from '../../reducers';
import { Action } from '../../actions';
import { createNotification } from '../NotificationBar/actions';
import { updateDriveItem } from '../DriveItemList/actions';
import { downloadThumb, removeThumb } from '../OfflineManager/actions';
import { Api } from '../../typings/api';
import ApiUtils from '../../utils/api';
import UserAgentUtils from '../../utils/userAgent';
import { DownloadPriority } from '../../utils/nativeApi';
import DriveItemUtils from '../../utils/driveItem';
import Utils from '../../utils';

export enum CoverImagePanelActionKeys {
	OPEN_PANEL = '@@coverImagePanel/OPEN_PANEL',
	CLOSE_PANEL = '@@coverImagePanel/CLOSE_PANEL',
}

interface OpenCoverImagePanel extends Action {
	type: CoverImagePanelActionKeys.OPEN_PANEL;
	driveItem: Api.DriveItem;
}

interface CloseCoverImagePanelAction extends Action {
	type: CoverImagePanelActionKeys.CLOSE_PANEL;
}

export type CoverImagePanelAction =
	OpenCoverImagePanel |
	CloseCoverImagePanelAction;

export const openCoverImagePanel = (driveItem: Api.DriveItem): OpenCoverImagePanel => ({
	type: CoverImagePanelActionKeys.OPEN_PANEL,
	driveItem,
});

export const closeCoverImagePanel = (): CloseCoverImagePanelAction => ({
	type: CoverImagePanelActionKeys.CLOSE_PANEL,
});

export const changeCoverImage = (coverGId: number) => async (dispatch: Dispatch<StoreState>, getState: () => StoreState): Promise<void> => {
	try {
		const { coverImagePanel: { driveItem } } = getState();
		const driveItemId = driveItem!.id;

		dispatch(closeCoverImagePanel());
		await ApiUtils.changeCoverImage(driveItemId, coverGId);
		const resource = await ApiUtils.getMeta(driveItemId);

		// if there is no cover image, server doesn't return 'icon' field in meta.
		// But it should be there for correct update in store and loading of default cover image
		if (!resource.icon) {
			resource.icon = '';
		}

		if (UserAgentUtils.isMobileApp) {
			if (DriveItemUtils.hasIcon(resource)) {
				const isExtensionChanged = Utils.getFileExtension(driveItem!.icon) !== Utils.getFileExtension(resource.icon);

				if (isExtensionChanged) {
					await dispatch(removeThumb(driveItemId, false));
				}

				await dispatch(downloadThumb(driveItemId, DownloadPriority.Normal, false, resource));
			} else {
				await dispatch(removeThumb(driveItemId));
			}
		}

		dispatch(updateDriveItem(resource));
	} catch (error) {
		dispatch(createNotification('error.cant_change_cover_image'));
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/CoverImagePanel/actions.ts